import { render, staticRenderFns } from "./purchase-header-block.vue?vue&type=template&id=7321df05&scoped=true&"
import script from "./purchase-header-block.vue?vue&type=script&lang=js&"
export * from "./purchase-header-block.vue?vue&type=script&lang=js&"
import style0 from "./purchase-header-block.vue?vue&type=style&index=0&id=7321df05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321df05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7321df05')) {
      api.createRecord('7321df05', component.options)
    } else {
      api.reload('7321df05', component.options)
    }
    module.hot.accept("./purchase-header-block.vue?vue&type=template&id=7321df05&scoped=true&", function () {
      api.rerender('7321df05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/purchase-header-block.vue"
export default component.exports